<template>
    <div id="mediaPopup">
        <div class="list" id="mediaListPopup">
            <div class="item" @click="openLocation" v-if="visitorLocationEnabled">
                <div class="icon">
                    <DynamicSvg color="#ED5023" name="Location" />
                </div>
                <div class="text black">{{ $t("visitorLanguage.submitLocation") }}</div>
            </div>

            <div class="item" @click="() => selectFile()" v-if="visitorFileSendEnabled">
                <div class="icon">
                    <DynamicSvg name="AddFile" />
                </div>
                <div class="text black">{{ $t("visitorLanguage.addFile") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../../../common/DynamicSvg.vue";
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "MediaPopup",
    components: { DynamicSvg },
    data() {
        return {
            cancels: [],
        };
    },
    computed: {
        ...mapState({
            visitorFileSendEnabled: (state) => _.get(state, "setting.settings.visitorFileSendEnabled", true),
            visitorLocationEnabled: (state) => _.get(state, "setting.settings.visitorLocationEnabled", true),
        }),
    },
    methods: {
        openLocation() {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (isSafari) {
                if (navigator.geolocation) {
                    const handleSuccess = (position) => {
                        // console.log(position);
                    };

                    const handleError = (error) => {
                        // console.log(error);
                    };

                    const requestLocation = () => {
                        navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
                    };

                    const handlePermissionDenied = () => {
                        alert(this.$t("visitorLanguage.youDidNotAllowLocationAccess"));
                    };

                    const showPermissionDialog = () => {
                        if (confirm(this.$t("visitorLanguage.allowLocationAccess"))) {
                            requestLocation();
                        } else {
                            handlePermissionDenied();
                        }
                    };

                    showPermissionDialog();
                } else {
                    alert(this.$t("visitorLanguage.locationNotSupported"));
                }
            } else {
                this.$emit("openLocation");
            }
        },

        selectFile() {
            document.getElementById("fileInput").click();
            this.$emit("closeMediaPopup");
        },
        mouseEvent() {
            const cb = (e) => {
                if (e.target.offsetParent == null || e.target.offsetParent == undefined) {
                    this.$emit("closeMediaPopup");
                }
                if (!document.getElementById("mediaListPopup").contains(e.target)) {
                    this.$emit("closeMediaPopup");
                }
            };
            window.addEventListener("click", cb);
            this.cancels.push(() => {
                window.removeEventListener("click", cb);
            });
        },
    },
    mounted() {
        setTimeout(() => this.mouseEvent(), 100);
    },
    beforeDestroy() {
        this.cancels.forEach((cb) => cb());
    },
};
</script>

<style lang="scss" scoped>
#mediaPopup {
    min-width: 200px;
    position: absolute;
    padding: 10px 10px;
    border-radius: 10px;
    bottom: 45px;
    right: -40px;
    background-color: white;
    color: var(--primary-text);
    box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.1);

    .list {
        .item {
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 20px;
            cursor: pointer;
            user-select: none;

            &:not(:last-child) {
                margin-bottom: 15px;
            }

            //&:hover {
            //    color: white;
            //    background-color: var(--header-color);
            //    .black {
            //        color: var(--header-text-color) !important;
            //    }
            //
            //    .icon {
            //        filter: brightness(0) invert(1);
            //        color: var(--header-text-color) !important;
            //
            //        svg {
            //            color: white !important;
            //            fill: white !important;
            //        }
            //
            //        path {
            //            fill: white !important;
            //            color: white !important;
            //        }
            //    }
            //}

            .text {
                font-size: 15px;
                font-weight: 500;
                line-height: 12px;
                margin-left: 15px;
            }

            .icon {
            }
            .black {
                color: black;
            }
            .black:hover {
                color: white;
            }
        }
    }
}
.black {
    color: black;
}
.black:hover {
    color: var(--header-text-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/MediaPopup.vue